import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TenantConfigService {
  public recaptchaSiteKeyV2: string | null = null;
  public recaptchaSiteKeyV3: string | null = null;
  private apiUrl: string;
  /**
   *
   */
  constructor(private httpClient : HttpClient) {
    this.apiUrl = `${window.location.origin}/KioskAPI/api`;
  }
  public loadConfig(): Promise<void> {
    const siteKeyV3= "6LdU5bIaAAAAAKA0n1Hx8F6CZ73E3_Ot_HYejjZN";
    const siteKeyV2 = "6Lf5HbQaAAAAAKvA-H7okgVQpSycEn49kSHX3pwP";
    return new Promise<void>((resolve, reject) => {
        ////do your initialisation stuff here  
        //this.httpClient.get(`${this.apiUrl}/TenantConfiguration`).subscribe(response=>{
          this.recaptchaSiteKeyV2 = siteKeyV2;
          this.recaptchaSiteKeyV3 = siteKeyV3;
          resolve();
        //});
    });
    }
  }

